package com.vidaensupalabra.vsp.datos

import kotlinx.serialization.Serializable

@Serializable
data class PlaylistItem(val videoId: String, val title: String)